var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.9478 0.277346L7.43455 0.62248C7.70988 0.64366 7.91591 0.884027 7.89473 1.15936L7.54959 5.6461C7.52842 5.92143 7.28805 6.12746 7.01272 6.10628C6.73739 6.0851 6.53136 5.84473 6.55254 5.5694L6.80509 2.28621L0.721597 7.50064L0.0708054 6.74138L6.1543 1.52695L2.87111 1.2744C2.59578 1.25322 2.38975 1.01285 2.41093 0.737525C2.43211 0.462196 2.67248 0.256167 2.9478 0.277346Z",
    fill: "#44444f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightUpArrow);
export default __webpack_public_path__ + "static/media/RightUpArrow.f2747c1333974ef8a16b827051046a92.svg";
export { ForwardRef as ReactComponent };